/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AdminHeader,
  AdminSpinner,
  AgentCustomerStatsResponse,
  Div,
  getCustomerStats,
} from '@vgrubs/components';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { GrubConciergeStats } from './GrubConciergeStats';
import { VGrubsEcosystemStats } from './VGrubsEcosystemStats';
import { VDriveStats } from './vDriveStats';
import { VGrubsStats } from './vGrubsStats';

export const CustomerStats = () => {
  const [stats, setStats] = useState<AgentCustomerStatsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const getStats = async () => {
    try {
      const { data } = await getCustomerStats();
      setStats(data.data);
    } catch {
      setStats(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStats();
  }, []);

  return (
    <>
      {loading && <AdminSpinner />}
      <AdminHeader title={'Customer Stats'} />

      <ContentContainer>
        <Div $flex $column $gap="16px" $desktop>
          {stats && (
            <>
              <VGrubsStats stats={stats} />
              <VGrubsEcosystemStats stats={stats} />
            </>
          )}
        </Div>
        <Div $flex $column $gap="16px" $mobile>
          {stats && (
            <>
              <VGrubsStats stats={stats} />
              <VDriveStats stats={stats} />
            </>
          )}
        </Div>
        <Div $flex $column $gap="16px" $desktop>
          {stats && (
            <>
              <VDriveStats stats={stats} />
              <GrubConciergeStats stats={stats} />
            </>
          )}
        </Div>
        <Div $flex $column $gap="16px" $mobile>
          {stats && (
            <>
              <GrubConciergeStats stats={stats} />
              <VGrubsEcosystemStats stats={stats} />
            </>
          )}
        </Div>
      </ContentContainer>
    </>
  );
};

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;
